import * as React from 'react';
import { BrPageContext, BrComponentContext } from '@bloomreach/react-sdk';

/**
 * Wrap Contexts from BR SDK in a hook so they're easier to mock in tests
 */ function useBrPageContext() {
    return React.useContext(BrPageContext);
}
function useBrComponentContext() {
    return React.useContext(BrComponentContext);
}

export { useBrComponentContext, useBrPageContext };
//# sourceMappingURL=context.js.map
